import React, { useState } from 'react'
import { IonContent, IonHeader, IonPage } from '@ionic/react'

import Toolbar from '../../components/Toolbar/Toolbar'
import './index.css'
import AffiliateFooter from './AffiliateFooter'
import AffilateHeader from './AffilateHeader'
import ShareModal from './ShareModal'
// import AddUserModal from './AddUserModal'

// const width = window.innerWidth

export default function AffiliateLayout({ children }) {
  const [share, setShare] = useState(false)
  return (
    <IonPage>
      <div className="lg:hidden">
        <IonHeader>
          <Toolbar />
        </IonHeader>
      </div>
      <IonContent>
        <section className="nw-affi-invite-wrapper affi-pd-bot">
          <div className="container_box">
            <AffilateHeader setShare={setShare} />
            {children}
            <AffiliateFooter setShare={setShare} />
          </div>
          {share && <ShareModal setOpenBonus={setShare} />}
        </section>
      </IonContent>
    </IonPage>
  )
}
